import { Departamento } from "./Departamento";
import { UsuarioConsentimento } from "./UsuarioConsentimento";

export class UsuarioDTO {

  id: number;
  nome: string;
  email: string;
  login: string;
  ativo: number;
  departamentoId?: number;
  departamento?: Departamento;
  areasInteresse?: Departamento[] = [];
  fotoPerfil: string;
  telefone?: string;
  celular?: string;
  perfil:  number;
  cdCliente?: number;
  senha?:string;
  cdContato: number;
  ufCliente?: string;
  nomeCliente?: string
  consentimento?: UsuarioConsentimento;
}
